.selector {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  height: 76px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid var(--adl-border-medium);
  background: var(--adl-surface-container);
  cursor: pointer;
}

.selectorSelected {
  border: 2px solid var(--adl-status-inform-medium);
  background: var(--adl-status-inform-lightest);
}

.selectorUnavailable {
  justify-content: center;
  border: 1px solid var(--adl-border-light);
  background: var(--adl-surface-disabled);
  cursor: default;
}

.unavailable {
  font-size: 12px;
  color: var(--adl-text-secondary);
}

.topLine {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 20px;
}

.label {
  font-weight: 600;
  font-size: 12px;
  color: var(--adl-text-primary);
}

.badge {
  background: var(--adl-status-inform-medium);
  color: var(--adl-status-inform-lightest);
  font-size: 12px;
  border-radius: 16px;
  padding: 2px 4px;
  line-height: 1;
  white-space: nowrap;
}

.middleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price {
  font-weight: 600;
  font-size: 14px;
  color: var(--adl-text-primary);
  text-align: right;
}

.transit {
  font-size: 12px;
  color: var(--adl-text-secondary);
}
